<template>
    <div>
        <p>{{ $t("profile.OTPdescription") }}</p>
        <hr />
        <form class="tw-space-y-5" data-test-id="user-password-form" @submit.prevent="onSubmit">
            <div>
                <l-input-text
                    id="newPassword"
                    :label="$t('profile.edit.passwordNew')"
                    type="password"
                    :value.sync="form.password"
                    class="tw"
                />
            </div>

            <l-text-alert
                v-if="hasError"
                class="tw-leading-none tw-text-sm"
                type="danger"
                data-test-id="error"
                :text="errorMessage"
            />

            <l-base-button
                type="submit"
                :button-types="['default', 'raised', 'primary']"
                :disabled="isLoading"
            >
                {{ $t("profile.edit.btnUpdatePassword") }}
            </l-base-button>
        </form>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LInputText from "@/components/LInputText";
import LTextAlert from "@/components/LTextAlert";
import LBaseButton from "@/components/LBaseButton";

export default {
    components: { LInputText, LTextAlert, LBaseButton },
    data() {
        return {
            hasError: false,
            errorMessage: "",
            isLoading: false,
            form: {
                password: "",
            },
        };
    },
    computed: {
        ...mapGetters({
            currentUser: "users/current/user",
            rights: "users/current/rights",
        }),
    },
    methods: {
        async onSubmit() {
            this.isLoading = true;
            this.hasError = false;

            try {
                await this.$store.dispatch("users/current/setPasswordFromOneTimePassword", {
                    payload: {
                        form: {
                            ...this.form,
                            username: this.currentUser.username,
                        },
                    },
                });

                this.$emit("close");
            } catch (err) {
                this.hasError = true;
                this.errorMessage = err.response?.data?.message ?? err.message;
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>
